module.exports = __webpack_public_path__ + "hero-next-768-c69bfb2ba49ec73d59612cf7009f89ab.bundle.png";